import * as moment from 'moment';
import { Date } from '@app/core/models';
import { sum } from '@app/shared/utils/array.utils';

interface DateRangeParams {
  startDate: string;
  endDate: string;
  incrementBy?: number;
}

export function forEachDate(
  { startDate, endDate, incrementBy = 1 }: DateRangeParams,
  callback: (date: string) => any,
): void {
  const date = moment(startDate);
  while (moment(date).isSameOrBefore(endDate)) {
    callback(date.format('YYYY-MM-DD'));
    date.add(incrementBy, 'day');
  }
}

export function getDates(params: DateRangeParams): string[] {
  const days: string[] = [];
  forEachDate(params, (date) => days.push(date));
  return days;
}

export function formatTime(time: string): string {
  const date = moment(time, 'HH:mm:ss');
  const format = date.minutes() ? 'h:mma' : 'ha';
  return date.format(format);
}

export function getDayOfWeekFromDate(date: string): Date.DayOfWeek {
  const day = moment(date).format('ddd').toUpperCase() as Date.Day;
  return Date.DayOfWeek[day];
}

export function getDayOfWeekFromDay(day: Date.Day): Date.DayOfWeek {
  return Date.DayOfWeek[day];
}

export const formatDateTime = (dateTime: string) => {
  const dateTimeFormat = moment(dateTime).isSame(moment(), 'day')
    ? 'h:mm a'
    : 'M/D/YY';
  return moment(dateTime).format(dateTimeFormat);
};

export const formatDateTimeWithWeekday = (dateTime: string) => {
  return moment(dateTime).format('ddd MM/DD/YYYY [at] LT');
};

export const isWithinDays = (dateTime: string, days: number) =>
  moment(dateTime).isAfter(moment().subtract(days, 'days').startOf('day'));

export const formatDateWithWeekDayShort = (dateTime: string) => {
  return moment(dateTime).format('ddd M/D');
};

export const formatDateWithWeekDayYearShort = (dateTime: string) => {
  return moment(dateTime).format('ddd M/D/YY');
};

export const addMinutes = (time: string, ...minutes: number[]) => {
  const totalMinutes = minutes.reduce(sum, 0);
  return moment(time, 'HH:mm:ss')
    .add(totalMinutes, 'minutes')
    .format('HH:mm:ss');
};

export const formatDateToDayNameDateMonthYear = (date: string) =>
  moment(date, 'YYYY-MM-DD').format('ddd MM/DD/YY');

export const formatTimeToHMM_A = (time: string) =>
  moment(time, 'hh:mm:ss').format('h:mm A');

export const formatTimeToHMMA = (time: string) =>
  moment(time, 'hh:mm:ss').format('h:mmA');
